// @flow
import React from "react";
import { StaggeredMotion, spring } from "react-motion";

const bouncySpringPreset = {
  stiffness: 250,
  damping: 16
};

const BouncyAnswer = ({ items }: { items: Array<any> }) =>
  <span>
    <StaggeredMotion
      defaultStyles={items.map(i => ({ y: 30 }))}
      styles={styles =>
        styles
          ? styles.map((_, i, arr) => {
              return i === 0
                ? { y: spring(0, bouncySpringPreset) }
                : {
                    y: spring(arr[i - 1].y, bouncySpringPreset)
                  };
            })
          : []}
    >
      {styles =>
        <span className="items">
          {items.map((item, i) =>
            <span
              key={i}
              className="item"
              style={{
                top: `${styles[i].y}px`,
                opacity: 1 - styles[i].y / 30
              }}
            >
              {item}
            </span>
          )}
        </span>}
    </StaggeredMotion>
    <style jsx>{`
        .items {
          position: relative;
        }
        .item {
          position: relative;
        }
      `}</style>
  </span>;

export default BouncyAnswer;



// WEBPACK FOOTER //
// ./src/components/Quiz/BouncyText.js